import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=0e30d40a&scoped=true&"
import script from "./Workplace.vue?vue&type=script&lang=js&"
export * from "./Workplace.vue?vue&type=script&lang=js&"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=0e30d40a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e30d40a",
  null
  
)

export default component.exports